import SelectInput from '../../../Common/ui/selectInput'
import Textarea from '../../../Common/ui/textArea'
import { Pagination, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PropTypes from 'prop-types'
import AddSquareIcon from '../../../Common/Icon/AddSquareIcon'
import '../../../Styles/AddCompliance.css'
import { useLocation } from 'react-router'
import { useTranslation } from 'react-i18next'
import { BIN_Q_APPLICABLE_ID, BIN_Q_NOT_APPLICABLE_ID } from 'src/Entities/Governance'
import ContentCircle from 'src/Common/ui/contentCircle'
import { cn } from 'src/lib/utils'

const BinaryQuestionTable = ({ activeTab, inputValidation, controls, control, data, errors, onInputChangeTextArea, onValueSelectChange, handleAddControls, handleDeleteControls, i }) => {
    const location = useLocation()
    const viewCondition = () => {
        const path = location.pathname
        if (path.includes('Add') || path.includes('Edit')) {
            return false
        } else {
            return true
        }
    }
    const [ currentPage, setCurrentPage ] = useState(1)

    const rowsPerPage = 5
    const totalPages = Math.ceil(data?.length / rowsPerPage)
    const handlePageChange = (event, value) => {
        setCurrentPage(value)
    }
    const answerConvert = (code) => {
        switch (code) {
        case BIN_Q_APPLICABLE_ID:
            return 'Applicable'
        case BIN_Q_NOT_APPLICABLE_ID:
            return 'Not Applicable'
        default:
        {
            const tempData = data.map((item, i) => {
                item.sNo = i + 1
                return item
            })
            const find = tempData.find((ele, i) => {
                if (ele.questionUID === code) {
                    return i + 1
                } return false
            })
            return `Question No ${find?.sNo}`
        }
        }
    }
    const [ paginatedData, setPaginatedData ] = useState([])
    const { t } = useTranslation()
    const [ disable, setDisable ] = useState(false)

    useEffect(() => {
        if (!viewCondition() && paginatedData.length > 0) {
            const find = paginatedData.every((ele) => {
                return ele.question
            })
            if (find) {
                setDisable(false)
            } else {
                setDisable(true)
            }
        }
    }, [paginatedData])
    useEffect(() => {
        if (data?.length > 0) {
            if (viewCondition()) {
                setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })).slice((currentPage - 1) * rowsPerPage, currentPage * rowsPerPage))
            }
            // setPaginatedData(data.map((item, i) => ({ ...item, sNo: i + 1 })))
        }
    }, [ data, currentPage ])
    const [ entries, setEntries ] = useState({
        entry: 0,
        from: 0,
        to: 0
    })
    useEffect(() => {
        setEntries({
            entry: data?.length,
            from: (currentPage - 1) * rowsPerPage + 1,
            to: (currentPage - 1) * rowsPerPage + paginatedData?.length - 1 + 1
        })
    }, [paginatedData])
    return (
        <>
            {<>
                <div style={{ display: activeTab === 1 ? 'block' : 'none', height: '100%' }}>
                    <div className='h-[86%]'>

                        <TableContainer className={'comp-table global-table'}>
                            <Table>
                                <TableHead>
                                    <TableRow className='!bg-none'>
                                        <TableCell sx={{ border: 'none', backgroundColor: 'transparent' }} colSpan={2}></TableCell>
                                        {viewCondition() && <TableCell sx={{ fontWeight: 600 }} align='center' className='binary-actions' colSpan={2}>{t('Actions')}</TableCell>}
                                    </TableRow>
                                    <TableRow>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600 }}>#</TableCell>
                                        <TableCell className='font-semibold !px-0' sx={{ fontWeight: 600 }}>
                                            <p className={'comp-table-th pl-3'}>
                                                <div>{t('Questions')}{!viewCondition() && <span className='text-[red]'>*</span>}</div>
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600 }}>
                                            <p className={'comp-table-th pl-3'}>
                                                {!viewCondition ? t('Yes') : t('Response')}
                                            </p>
                                        </TableCell>
                                        <TableCell align='center' className='font-semibold !px-0' sx={{ fontWeight: 600 }}>
                                            <p className={'comp-table-th pl-3'}>
                                                {!viewCondition ? t('No') : t('Actions')}
                                            </p>
                                        </TableCell>
                                        {data.length > 1 && !viewCondition() && <TableCell></TableCell>}
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(viewCondition() ? paginatedData : data)?.map((item, j) => {
                                        item.sNo = j + 1
                                        return (
                                            <>
                                                <TableRow key={item.id} sx={{ height: '30px' }}>
                                                    <TableCell align='center' rowSpan={!viewCondition() && 2}>
                                                        <div className='w-full flex justify-center'>
                                                            <ContentCircle className={'min-h-6 text-center bg-[hsl(var(--primary-table-head))] min-w-6'} contentClassName={'text-primary text-sm'} content={item.sNo} />

                                                        </div>
                                                    </TableCell>
                                                    <TableCell sx={{ height: '100%' }} rowSpan={!viewCondition() && 2}>
                                                        <p className='comp-table-td'>
                                                            {viewCondition()
                                                                ? <div className='h-full' style={{ whiteSpace: 'wrap' }}>{item.question}</div>
                                                                : <div className='h-full'>
                                                                    <Textarea
                                                                        errors={errors}
                                                                        control={control}
                                                                        required
                                                                        rules={{
                                                                            validate: (value) => {
                                                                                return inputValidation(value, value?.length < 251, 'This field is required', 'Characters should be less than 250')
                                                                            }
                                                                        }}
                                                                        name={`binaryQuestions-question-${j}`}
                                                                        placeholder="Enter a Question"
                                                                        type="text"
                                                                        onValueChange={(e) => onInputChangeTextArea(e, `binaryQuestions-question-${j}`)}
                                                                        value={item.question}
                                                                        defaultValue={item.question}
                                                                        className='!border-none !ring-0 !shadow-none !h-auto min-h-2 !max-h-14 !p-0'
                                                                        maxLength={250}
                                                                    />
                                                                </div>}
                                                        </p>
                                                    </TableCell>
                                                    {!viewCondition() && <TableCell align='center' sx={{ color: 'hsl(var(--primary))' }}>
                                                        <p className='comp-table-td w-full flex justify-center'>{t('Yes')}</p>
                                                    </TableCell>}
                                                    <TableCell align='center' sx={{}}>
                                                        <p className='comp-table-td w-full'>
                                                            <p className='w-full flex justify-center'>

                                                                <p className='flex !w-[150px] flex-col  items-center justify-center'>
                                                                    {viewCondition()
                                                                        ? <div>{answerConvert(item.connections[0]?.hieID === '0' ? item.connections[0]?.action : item.connections[0]?.hieID)}</div>
                                                                        : <SelectInput
                                                                            required
                                                                            control={control}
                                                                            errors={errors}
                                                                            name={`binaryOption-yes-${j}-${0}`}
                                                                            placeholder="Select Action"
                                                                            rules={{ required: 'This field is Required' }}
                                                                            onValueChange={(value) => onValueSelectChange(value, `binaryOption-yes-${j}-${0}`)}
                                                                            value={item.connections[0]?.action !== 0 ? item.connections[0]?.action : item.connections[0]?.hieID || ''}
                                                                            options={[
                                                                                { label: 'Applicable', value: 1 },
                                                                                { label: 'Not Applicable', value: 2 },
                                                                                ...data.map((ele, i) => {
                                                                                    if (ele.questionUID !== item.questionUID) {
                                                                                        return {
                                                                                            label: `Question no ${i + 1}`, value: ele.questionUID
                                                                                        }
                                                                                    }
                                                                                    return null
                                                                                }).filter(ele => ele !== null)
                                                                            ]}
                                                                            className='w-[150px] !shadow-none !ring-0 !outline-none translate-y-2 !mt-0' />}
                                                                </p>
                                                            </p>
                                                        </p>
                                                    </TableCell>
                                                    {viewCondition() && <TableCell align='center' sx={{}}>
                                                        <p className='comp-table-td w-full flex justify-center'>{answerConvert(item.connections[1]?.hieID === '0' ? item.connections[1]?.action : item.connections[1]?.hieID)}</p>
                                                    </TableCell>}
                                                    {data.length > 1 && !viewCondition() && <TableCell rowSpan={2}><div onClick={() => handleDeleteControls('binaryQuestions', j)} className='flex justify-center cursor-pointer w-10'><img src='/Common/Icon/DeleteIconGov.svg' className='w-[25px] h-[25px]' /></div></TableCell>}

                                                </TableRow>
                                                {!viewCondition() && <TableRow>
                                                    {!viewCondition() && <TableCell align='center' sx={{ color: 'hsl(var(--primary))' }}>
                                                        <p className='comp-table-td w-full flex justify-center'>{t('No')}</p>
                                                    </TableCell>}
                                                    <TableCell align='center' >
                                                        <p className='comp-table-td w-full'>
                                                            <p className='w-full flex justify-center'>

                                                                <p className='flex !w-[150px] flex-col  items-center justify-center'>
                                                                    <SelectInput
                                                                        required
                                                                        control={control}
                                                                        errors={errors}
                                                                        name={`binaryOption-no-${j}-${1}`}
                                                                        rules={{ required: 'This field is Required' }}
                                                                        placeholder="Select Action"
                                                                        onValueChange={(value) => onValueSelectChange(value, `binaryOption-no-${j}-${1}`)}
                                                                        value={item.connections[1]?.action !== 0 ? item.connections[1]?.action : item.connections[1]?.hieID}
                                                                        options={[
                                                                            { label: 'Applicable', value: 1 },
                                                                            { label: 'Not Applicable', value: 2 },
                                                                            ...data.map((ele, i) => {
                                                                                if (ele.questionUID !== item.questionUID) {
                                                                                    return {
                                                                                        label: `Question no ${i + 1}`, value: ele.questionUID
                                                                                    }
                                                                                }
                                                                                return null
                                                                            }).filter(ele => ele !== null)
                                                                        ]}
                                                                        className='!shadow-none flex !ring-0 !outline-none translate-y-2 !mt-0' />
                                                                </p>
                                                            </p>
                                                        </p>
                                                    </TableCell>
                                                </TableRow>}
                                            </>

                                        )
                                    })}
                                </TableBody>
                            </Table>
                        </TableContainer>
                    </div>

                    {viewCondition() && data.length > 0 && <div className="border-t-2 border-t-primary-foreground flex items-center justify-between px-4 h-[14%]">
                        <Typography className="text-muted !text-h4">
                        Showing data {entries.from} to {entries.to} of {entries.entry} entries
                        </Typography>
                        <Pagination
                            sx={{ marginLeft: 'auto' }}
                            count={totalPages}
                            page={currentPage}
                            onChange={handlePageChange}
                            variant="outlined"
                            shape="rounded" />
                    </div>}
                    {!viewCondition() && <div className='w-full flex justify-end mt-5 pr-1 cursor-pointer'>
                        <div className={cn(disable ? 'bg-popover pr-1 rounded-sm !text-card pointer-events-none' : '', 'flex gap-2 items-center text-primary')} onClick={() => { handleAddControls('binaryQuestions') }}><AddSquareIcon fill={disable ? 'hsl(var(--card))' : 'hsl(var(--primary))'}/> <span>New</span></div>
                    </div>}
                </div>
            </>
            }
        </>
    )
}

BinaryQuestionTable.propTypes = {
    controls: PropTypes.any,
    control: PropTypes.any,
    errors: PropTypes.any,
    data: PropTypes.any,
    onInputChangeTextArea: PropTypes.func,
    onValueSelectChange: PropTypes.func,
    handleAddControls: PropTypes.func,
    handleDeleteControls: PropTypes.func,
    i: PropTypes.number,
    activeTab: PropTypes.any,
    inputValidation: PropTypes.func
}

export default BinaryQuestionTable
